export class PessoaMassActionRequest {
    public isAtivo: boolean | null;
    public idVendedor: number | null;
    public listIdPessoa: number[] = [];
}